import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setActive } from '../store/DocumentStore';
import config from '../config';
import Menu from './Menu';
import './Documents.css';
import folderIcon from '../images/documents.png';

const Documents = () => {
    const dispatch = useDispatch();
    const documents = useSelector((state) => state.documentState.documents);
    const activeDocument = useSelector((state) => state.documentState.activeDocument);

    const sortedDocs = documents && documents.map(x => ({ ...x, category: x.category || '' })).sort((a, b) => a.category > b.category ? 1 : a.category < b.category ? -1 : 0);
    const oldCategories = sortedDocs && sortedDocs.map(item => item.category).filter((item, i, ar) => ar.indexOf(item) === i);

    const [activeCat, setActiveCat] = useState((oldCategories && oldCategories[0]) || '');

    const categories = convertToFolderStructure(oldCategories);

    useEffect(() => {
        if (!activeCat || !sortedDocs) return;
        
        // First try to find documents that exactly match the active category
        let filtered = sortedDocs.filter(x => x.category.toUpperCase().replace(/\s+/g, '') === activeCat);
        
        // If no exact match, find documents that start with the active category path (subcategory documents)
        if (filtered.length === 0) {
            filtered = sortedDocs.filter(x => x.category.toUpperCase().replace(/\s+/g, '').startsWith(activeCat + '|'));
        }
        
        // If still no documents found, find documents from any parent category that's currently visible
        if (filtered.length === 0) {
            const categoryParts = activeCat.split('|');
            for (let i = categoryParts.length - 1; i >= 0; i--) {
                const parentPath = categoryParts.slice(0, i + 1).join('|');
                filtered = sortedDocs.filter(x => x.category.toUpperCase().replace(/\s+/g, '') === parentPath);
                if (filtered.length > 0) break;
            }
        }
        
        if (filtered && filtered.length > 0) {
            dispatch(setActive(filtered[0]));
        }
        //eslint-disable-next-line
    }, [activeCat]);

    return (
        <div className="App">
            <Menu />
            <div className='documents'>
                <div className='documents-container'>
                    {categories && categories.map(c =>
                        renderCategory(c, activeCat, setActiveCat, sortedDocs, activeDocument, dispatch)
                    )}
                </div>
                {activeDocument &&
                    <div className='preview'>
                        <embed key={`${config.server}${activeDocument.path}`} src={`${config.server}${activeDocument.path}`} alt="pdf" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" />
                    </div>
                }
            </div>
        </div>
    );
};

function renderCategory(category, activeCat, setActiveCat, sortedDocs, activeDocument, dispatch, path, depth = 0) {
    const fullPath = path ? `${path}|${category.name}` : category.name;
    const normalizedPath = fullPath.replace(/\s+/g, '');
    const indentClass = `category-item depth-${depth}`;

    const toggleCategory = () => {
        setActiveCat(normalizedPath === activeCat ? '' : normalizedPath);
    };

    const isMatchingCategory = (documentCategory) => {
        return documentCategory.toUpperCase().replace(/\s+/g, '') === normalizedPath;
    };

    // Check if this category is currently active (exact match)
    const isCurrentlyActive = normalizedPath === activeCat;
    
    // Check if this category should be expanded (either active itself or a parent of the active category)
    const isExpanded = isCurrentlyActive || activeCat.startsWith(normalizedPath + '|');
    
    // Check if subcategories should be shown (when this category is expanded)
    const shouldShowSubcategories = isExpanded;
    
    // Check if documents should be shown (when this category is in the active path)
    const shouldShowDocuments = isExpanded;

    return (
        <div key={category.name} className={indentClass}>
            <h2 className={isCurrentlyActive ? 'expanded' : ''} onClick={toggleCategory}>
                <img src={folderIcon} alt={'folder'} />
                {`${category.name || 'Ingen kategori'}`}
                <span className={'expand'}>{isExpanded ? '-' : '+'}</span>
            </h2>
            {shouldShowDocuments && sortedDocs && sortedDocs.filter(x => isMatchingCategory(x.category)).map((d) => {
                return (
                    <div key={d.id} onClick={() => dispatch(setActive(d))} className={`document ${activeDocument && d.id === activeDocument.id ? 'active' : ''}`}>
                        {d.name}
                    </div>
                );
            })}
            {shouldShowSubcategories && category.subcategories && category.subcategories.map(subCat => renderCategory(subCat, activeCat, setActiveCat, sortedDocs, activeDocument, dispatch, fullPath, depth + 1))}
        </div>
    );
}

function convertToFolderStructure(categories) {
    const categoryMap = {};

    for (const category of categories) {
        const categoryParts = category.split('|').map(part => part.trim().toUpperCase());
        let currentCategoryMap = categoryMap;

        for (const part of categoryParts) {
            if (!currentCategoryMap[part]) {
                currentCategoryMap[part] = {};
            }
            currentCategoryMap = currentCategoryMap[part];
        }
    }

    function convertMapToStructure(map) {
        const folderStructure = [];

        for (const key in map) {
            const subfolder = {
                name: key,
                subcategories: convertMapToStructure(map[key]),
            };
            folderStructure.push(subfolder);
        }

        return folderStructure;
    }

    return convertMapToStructure(categoryMap);
}

export default Documents;